module.exports = __webpack_public_path__ + "img/spring_trip-20160416-23.d2f98e06.jpg";